import type { ArticleFrontmatterInput } from './wikiApi';
import { isValidVerifyEvery } from './verify-interval';
export interface ArticleDraftFields {
  title: string; type: ArticleFrontmatterInput['type']; blocks: string[]; category: string; tags: string[];
  excerpt: string; requiresAck: boolean; roles: string[]; cover: string; icon: string;
  /** Владелец — человек (ownerId) ЛИБО отдел (ownerDept = код); ownerName — подпись выбранного. */
  ownerId: string | null; ownerDept: string | null; ownerName: string | null; verifyEvery: number | null;
  downloadable: boolean; notify: boolean; kpi: string; publishAt: string; effectiveFrom: string;
  status: NonNullable<ArticleFrontmatterInput['status']>; summary: string;
}
export interface ArticleDraft { html: string; savedAt: number; baseVersion?: number; fields: ArticleDraftFields }
export const articleDraftKey = (userId: string, slug: string) => `wiki-draft:v2:${userId}:${slug}`;
export function parseArticleDraft(raw: string | null): ArticleDraft | null {
  if (!raw) return null;
  try {
    const d = JSON.parse(raw);
    if (!d || typeof d.html !== 'string' || !Number.isFinite(d.savedAt) || !d.fields || typeof d.fields !== 'object') return null;
    if (d.baseVersion !== undefined && (!Number.isInteger(d.baseVersion) || d.baseVersion < 1)) return null;
    const f = d.fields;
    for (const key of ['title','category','excerpt','cover','icon','kpi','publishAt','effectiveFrom','status','summary']) if (typeof f[key] !== 'string') return null;
    for (const key of ['blocks','tags','roles']) if (!Array.isArray(f[key]) || f[key].some((v: unknown) => typeof v !== 'string')) return null;
    for (const key of ['requiresAck','downloadable','notify']) if (typeof f[key] !== 'boolean') return null;
    // Черновики, сохранённые до появления владельца-отдела, поля ownerDept не имеют: это «отдела нет».
    if (f.ownerDept === undefined) f.ownerDept = null;
    for (const key of ['ownerId','ownerDept','ownerName']) if (f[key] !== null && typeof f[key] !== 'string') return null;
    if (f.ownerId && f.ownerDept) return null;
    if (f.verifyEvery !== null && !isValidVerifyEvery(f.verifyEvery)) return null;
    if (!['DRAFT','REVIEW','PUBLISHED','ARCHIVED'].includes(f.status)) return null;
    if (f.type !== undefined && !['article','instruction','checklist','regulation','faq','standard','wizard_step','decision_tree','document_template','publication'].includes(f.type)) return null;
    return d as ArticleDraft;
  } catch { return null; }
}

/**
 * В тексте нет ничего: ни слов, ни картинок, ни таблиц, ни видео. Такой черновик остаётся от сессии, где
 * совместный редактор открылся пустым (16.10.2026), — восстанавливать его поверх живой статьи нельзя.
 */
export function isBlankArticleHtml(html: string): boolean {
  if (/<(img|video|iframe|table|hr|figure)\b/i.test(html)) return false;
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;| /g, ' ').trim() === '';
}
